<template>
  <div>
    <modal v-if="hasExpired" force small class="timeout">
      <div slot="body">
        <div class="p-5 text-center">
          <img :src="`${cdn}/images/expired.png`" class="w-25 mb-3" :alt="$t('general.quote_expired')">
          <h2 class="text-center">{{ $t('general.quote_expired') }}</h2>
          <button type="button" @click="refresh" :disabled="disabled" class="btn btn-secondary btn-lg p-4 mt-3">{{ $t('general.search_again') }}</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { sync, call, get } from "vuex-pathify";
import mixins from "@/mixins";
import { Modal } from "@/components";

export default {
  name: "timeout",
  mixins: [mixins.globals],
  components: { Modal },
  computed: {
    quoteTimestamp: sync('quote/_timestamp'),
    quoteCategory: get('quote/category'),
    moreInfo: sync("modals/moreInfo"),
    save: sync("modals/save"),
    reveal: sync("modals/reveal"),
    editTimes: sync("payment/editTimes"),
    password: sync("modals/passwordReset"),
    quote: sync("quote"),
    expires() {
      let timestampDate = new Date(this.quoteTimestamp);
      return new Date(timestampDate.getTime() + this.timeoutLimit * 60000)
    },
    remaining() {
      return (this.expires - this.time);
    },
    hasExpired() {
      return this.remaining < 1;
    },
  },
  data() {
    return {
      interval: null,
      time: new Date().getTime(),
      disabled: false,
    };
  },
  mounted() {
    this.disabled = false;
    this.interval = setInterval(() => {
      this.countdown();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    generate: call("quote/updateQuote"),
    load: call("results/getResults"),
    reset: call("cart/resetCart"),
    countdown() {
      this.time = new Date();
      if(this.remaining < 1) {
        this.moreInfo = false;
        this.reveal = false;
        this.save = false;
        this.password = false;
        this.editTimes = false;
      }
    },
    refresh() {
      this.disabled = true;
      this.load().then(() => {

        if(this.$route.name === 'payment')  {

          this.reset();
          this.disabled = false;
          delete this.quote._timestamp;
          delete this.quote.quoteID;
          return this.$router.replace({ path: `${this.category}-results`, query: this.quote }).catch(() => {});

        } else {
          this.disabled = false;
          window.location.reload()
        }
      });      
    },
  },
};
</script>